var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "csaedit" }, [
    _c("div", { staticClass: "flex-container dark-text" }, [
      _c("div", { staticClass: "flex-col flex-1" }, [
        _c("div", { staticClass: "flex-row flex-1 container mb-10" }, [
          _c("div", { staticClass: "flex-col flex-1" }),
          _c("div", { staticClass: "flex-col flex-10 boxborder" }, [
            _c(
              "div",
              {
                staticClass: "flex-row flex-1 asset-name",
                staticStyle: {
                  "justify-content": "center",
                  "align-items": "center",
                },
              },
              [
                _c("div", { staticClass: "flex-col flex-1" }),
                _c(
                  "div",
                  {
                    staticClass: "flex-col flex-10",
                    staticStyle: { "align-items": "center" },
                  },
                  [_vm._v(_vm._s(_vm.assetName))]
                ),
                _c("div", { staticClass: "flex-col flex-1" }),
              ]
            ),
            _c("div", { staticClass: "flex-row flex-1 mt-2" }, [
              _c("div", { staticClass: "flex-col flex-5" }, [
                _c("div", { staticClass: "flex-row flex-1 component-header" }, [
                  _vm._v("Commercial and Sustainability Assessment"),
                ]),
                _c("div", { staticClass: "flex-row flex-2 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.commercialOutlookLabel) + ": "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [
                          _vm._v(
                            _vm._s(_vm.csaLabels.commercialOutlookSubLabel1) +
                              ": "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.csaData.commercialOutlookSubValue1,
                                expression:
                                  "csaData.commercialOutlookSubValue1",
                              },
                            ],
                            domProps: {
                              value: _vm.csaData.commercialOutlookSubValue1,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.csaData,
                                  "commercialOutlookSubValue1",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c(
                        "div",
                        { staticClass: "flex-col flex-1 flex-justify-center" },
                        [
                          _vm._v(
                            _vm._s(_vm.csaLabels.commercialOutlookSubLabel2) +
                              ": "
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "flex-col flex-1" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.csaData.commercialOutlookSubValue2,
                              expression: "csaData.commercialOutlookSubValue2",
                            },
                          ],
                          domProps: {
                            value: _vm.csaData.commercialOutlookSubValue2,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.csaData,
                                "commercialOutlookSubValue2",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.currentValueDriverLabel) + ": "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-1 pre-formatted" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.currentValueDriver,
                          expression: "csaData.currentValueDriver",
                        },
                      ],
                      domProps: { value: _vm.csaData.currentValueDriver },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData,
                            "currentValueDriver",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [_vm._v(_vm._s(_vm.csaLabels.ltContractValueLabel) + ": ")]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.ltContractValue,
                          expression: "csaData.ltContractValue",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.ltContractValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData,
                            "ltContractValue",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-2 flex-justify-center" },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.runningRegimeTrendLabel) + ": "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.runningRegime,
                          expression: "csaData.runningRegime",
                        },
                      ],
                      domProps: { value: _vm.csaData.runningRegime },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData,
                            "runningRegime",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 center-align",
                      staticStyle: { "font-size": "2rem" },
                    },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.csaData.runningTrend,
                              expression: "csaData.runningTrend",
                            },
                          ],
                          attrs: { name: "rtrend" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.csaData,
                                "runningTrend",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "Up" } }, [
                            _vm._v("Up"),
                          ]),
                          _c("option", { attrs: { value: "Unchanged" } }, [
                            _vm._v("Unchanged"),
                          ]),
                          _c("option", { attrs: { value: "Down" } }, [
                            _vm._v("Down"),
                          ]),
                          _c(
                            "option",
                            { attrs: { value: "No running forecasted" } },
                            [_vm._v(_vm._s(_vm.$t("noRunningForecasted")))]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "flex-row flex-2 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.csaLabels.co2AbatementCostsLabel.replace(
                              "CO2",
                              "CO<sub>2</sub>"
                            ) + ":"
                          ),
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csaData.co2AbatementCostsText1,
                            expression: "csaData.co2AbatementCostsText1",
                          },
                        ],
                        staticClass: "smallInputBox",
                        domProps: { value: _vm.csaData.co2AbatementCostsText1 },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.csaData,
                              "co2AbatementCostsText1",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csaData.co2AbatementCostsText2,
                            expression: "csaData.co2AbatementCostsText2",
                          },
                        ],
                        staticClass: "smallInputBox",
                        domProps: { value: _vm.csaData.co2AbatementCostsText2 },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.csaData,
                              "co2AbatementCostsText2",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csaData.co2AbatementCostsValue1,
                            expression: "csaData.co2AbatementCostsValue1",
                          },
                        ],
                        staticClass: "smallInputBox",
                        domProps: {
                          value: _vm.csaData.co2AbatementCostsValue1,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.csaData,
                              "co2AbatementCostsValue1",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csaData.co2AbatementCostsValue2,
                            expression: "csaData.co2AbatementCostsValue2",
                          },
                        ],
                        staticClass: "smallInputBox",
                        domProps: {
                          value: _vm.csaData.co2AbatementCostsValue2,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.csaData,
                              "co2AbatementCostsValue2",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _vm._v(
                        _vm._s(_vm.csaLabels.specificEmissionsLabel) + ": "
                      ),
                    ]),
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _vm._v(_vm._s(_vm.csaData.specificEmissionsText)),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("div", { staticClass: "flex-row flex-1 flex-center" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csaData.specificEmissionsValue,
                            expression: "csaData.specificEmissionsValue",
                          },
                        ],
                        staticClass: "smallInputBox",
                        domProps: { value: _vm.csaData.specificEmissionsValue },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.csaData,
                              "specificEmissionsValue",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "flex-row flex-1 flex-center" }, [
                      _vm._v(
                        _vm._s(_vm.csaLabels.specificEmissionsMeasureUnitLabel)
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [
                      _vm._v(
                        _vm._s(_vm.csaLabels.commentSustainabilityLabel) + ": "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-2 flex-wrap" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.commentSustainabilityValue,
                          expression: "csaData.commentSustainabilityValue",
                        },
                      ],
                      domProps: {
                        value: _vm.csaData.commentSustainabilityValue,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData,
                            "commentSustainabilityValue",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [_vm._v(_vm._s(_vm.csaLabels.externalRisksLabel) + ": ")]
                  ),
                  _c("div", { staticClass: "flex-col flex-2" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.externalRisksValue,
                          expression: "csaData.externalRisksValue",
                        },
                      ],
                      domProps: { value: _vm.csaData.externalRisksValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData,
                            "externalRisksValue",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [_vm._v(_vm._s(_vm.csaLabels.pmaViewLabel) + ": ")]
                  ),
                  _c("div", { staticClass: "flex-col flex-2" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.pmaViewValue,
                          expression: "csaData.pmaViewValue",
                        },
                      ],
                      domProps: { value: _vm.csaData.pmaViewValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData,
                            "pmaViewValue",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-5" }, [
                _vm._m(0),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center",
                      staticStyle: { "align-items": "center" },
                    },
                    [_vm._v("FCF")]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.fcfValues[0],
                          expression: "csaData.fcfValues[0]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.fcfValues[0] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.fcfValues,
                            0,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.fcfValues[1],
                          expression: "csaData.fcfValues[1]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.fcfValues[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.fcfValues,
                            1,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.fcfValues[2],
                          expression: "csaData.fcfValues[2]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.fcfValues[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.fcfValues,
                            2,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.fcfValues[3],
                          expression: "csaData.fcfValues[3]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.fcfValues[3] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.fcfValues,
                            3,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.fcfValues[4],
                          expression: "csaData.fcfValues[4]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.fcfValues[4] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.fcfValues,
                            4,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center",
                      staticStyle: { "align-items": "center" },
                    },
                    [_vm._v("P5")]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.p5Values[0],
                          expression: "csaData.p5Values[0]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.p5Values[0] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.csaData.p5Values, 0, $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.p5Values[1],
                          expression: "csaData.p5Values[1]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.p5Values[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.csaData.p5Values, 1, $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.p5Values[2],
                          expression: "csaData.p5Values[2]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.p5Values[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.csaData.p5Values, 2, $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._m(1),
                  _vm._m(2),
                ]),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center",
                      staticStyle: { "align-items": "center" },
                    },
                    [_vm._v("P95")]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-col flex-1 flex-justify-center" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.csaData.p95Values[0],
                            expression: "csaData.p95Values[0]",
                          },
                        ],
                        staticClass: "smallInputBox",
                        domProps: { value: _vm.csaData.p95Values[0] },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.csaData.p95Values,
                              0,
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.p95Values[1],
                          expression: "csaData.p95Values[1]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.p95Values[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.p95Values,
                            1,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.p95Values[2],
                          expression: "csaData.p95Values[2]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.p95Values[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.p95Values,
                            2,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._m(3),
                  _vm._m(4),
                ]),
                _vm._m(5),
                _c("div", { staticClass: "flex-row flex-1 light-padding" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-col flex-1 flex-justify-center",
                      staticStyle: { "align-items": "center" },
                    },
                    [_vm._v("CO2")]
                  ),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.absoluteCo2Values[0],
                          expression: "csaData.absoluteCo2Values[0]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.absoluteCo2Values[0] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.absoluteCo2Values,
                            0,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.absoluteCo2Values[1],
                          expression: "csaData.absoluteCo2Values[1]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.absoluteCo2Values[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.absoluteCo2Values,
                            1,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.absoluteCo2Values[2],
                          expression: "csaData.absoluteCo2Values[2]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.absoluteCo2Values[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.absoluteCo2Values,
                            2,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.absoluteCo2Values[3],
                          expression: "csaData.absoluteCo2Values[3]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.absoluteCo2Values[3] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.absoluteCo2Values,
                            3,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.csaData.absoluteCo2Values[4],
                          expression: "csaData.absoluteCo2Values[4]",
                        },
                      ],
                      staticClass: "smallInputBox",
                      domProps: { value: _vm.csaData.absoluteCo2Values[4] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.csaData.absoluteCo2Values,
                            4,
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "flex-row flex-1 light-padding mb-1" }, [
              _c(
                "div",
                { staticClass: "flex-col flex-1 flex-justify-center" },
                [_vm._v("*Comment: ")]
              ),
              _c("div", { staticClass: "flex-col flex-5" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.updComment,
                      expression: "updComment",
                    },
                  ],
                  domProps: { value: _vm.updComment },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.updComment = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "flex-row flex-1 flex-justify-center mt-5 flex-justify-between",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-col flex-1 flex-justify-end",
                    staticStyle: { "align-items": "center" },
                  },
                  [
                    _c(
                      "button",
                      { staticClass: "add-button", on: { click: _vm.home } },
                      [_vm._v("Home")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-col flex-1 flex-justify-end",
                    staticStyle: { "align-items": "center" },
                  },
                  [
                    _c(
                      "button",
                      { staticClass: "add-button", on: { click: _vm.reset } },
                      [_vm._v("Reset")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "flex-col flex-1 flex-justify-end",
                    staticStyle: { "align-items": "center" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "add-button",
                        on: { click: _vm.saveCSAData },
                      },
                      [_vm._v("Save")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "flex-col flex-1" }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-row flex-1" }, [
      _c("div", { staticClass: "fcf-chart", attrs: { id: "fcf-chart" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-col flex-1" }, [
      _c("input", {
        staticClass: "smallInputBox",
        attrs: { value: "N/A", readonly: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-col flex-1" }, [
      _c("input", {
        staticClass: "smallInputBox",
        attrs: { value: "N/A", readonly: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-col flex-1" }, [
      _c("input", {
        staticClass: "smallInputBox",
        attrs: { value: "N/A", readonly: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-col flex-1" }, [
      _c("input", {
        staticClass: "smallInputBox",
        attrs: { value: "N/A", readonly: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-row flex-1" }, [
      _c("div", { staticClass: "co2-chart", attrs: { id: "co2-chart" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }